import React, {useState, useRef, useEffect} from "react";
import FJMediaCollectionView from "../view/stockVideo/FJMediaCollectionView";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJPureLoading from "../view/stockVideo/FJPureLoading";
import FJFetchError from "../view/stockVideo/FJFetchError";
import FJNetworkStore from "../../../store/FJNetworkStore";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJMusicSearchView from "../view/stockVideo/music/FJMusicSearchView";

function FJMusicCollectionContainer(props) {

	const {STOCK_SEARCH_LOADING, STOCK_SEARCH_SUCCESS, STOCK_SEARCH_ERROR, STOCK_SEARCH_NONE, STOCK_SEARCH_END} = FJViewConstant;
	const {active, isOpenLeftMenu, addMusic, mediaList} = props;
	const [status, updateStatus] = useState(STOCK_SEARCH_LOADING);
	const [expandData, updateExpandData] = useState(null);
	const [collections, updateCollections] = useState([]);
	const numPerPage = 30;
	const stateRef = useRef();
	const initAudioCollections = () => {
		FJNetworkStore.getMediaCollections({type: FJCoreConstant.AUDIO}).then(list => {
			updateStatus(STOCK_SEARCH_SUCCESS);
			updateCollections(list.map(item => {
				item.cover = item.imageUrl;
				return item;
			}));
		}).catch(() => {
			updateStatus(STOCK_SEARCH_ERROR);
		})
	};
	const nextPage = () => {
		const {id, isEndTip, page} = expandData;
		if (!isEndTip) {
			let allItems = collections.find(collection => collection.id === id).items;
			let nextPage = page + 1;
			let nextItems = allItems.slice(0, nextPage * numPerPage);
			updateExpandData({
				...(expandData || {}),
				page: nextPage,
				items: nextItems,
				status: nextItems.length === allItems.length && STOCK_SEARCH_END,
			})
		}
	};
	const handleCollection = (name) => {
		let {page} = expandData || {page: 1};
		let {id, items: allItems} = collections.find(c => c.name === name);
		if (allItems) {
			updateExpandData(
				{...(expandData || {}),
					id,
					name,
					page,
					items: allItems.slice(0, numPerPage),
					status: allItems.length > numPerPage ? '' : STOCK_SEARCH_END,
				});
		} else {
			updateExpandData({...(expandData || {}), status: STOCK_SEARCH_LOADING});
			FJNetworkStore.getMediaCollectionItems({id, page, type: FJCoreConstant.AUDIO}).then(list => {
				if(!stateRef.current) {
					return;
				}
				let _collections = collections.map(collection => {
					if (collection.id === id) {
						collection.items = list;
					}
					return collection;
				});
				let items = list.slice(0, numPerPage);
				let status = '';
				let length = items.length;
				if (length === 0) {
					status = STOCK_SEARCH_NONE;
				} else if (length <= numPerPage) {
					status = STOCK_SEARCH_END;
				}
				updateCollections(_collections);
				updateExpandData({...(expandData || {}), id, name, page, items, status});
			}).catch(() => {
				if(!stateRef.current) {
					return;
				}
				updateExpandData({...(expandData || {}), id, name, status: STOCK_SEARCH_ERROR});
			});
		}
	};
	const retry = () => {
    const {name} = expandData || {};
    if (name) {
      handleCollection(name);
    }
  };
	const back = () => {
		updateExpandData(null);
	};
	stateRef.current = expandData;

	useEffect(initAudioCollections, []);

	const {status: searchStatus, name: collectionName, items} = expandData || {};
	const translateX = isOpenLeftMenu ? '145px' : '0';
	switch (status) {
		case STOCK_SEARCH_SUCCESS:
			return (
				<>
					<FJMusicSearchView active={active && expandData}
					                   mediaList={mediaList}
					                   isCollectionMode
					                   backCate={back}
                             onRetry={retry}
					                   searchStatus={searchStatus}
					                   collectionName={collectionName}
					                   collections={items}
					                   searchNextPage={nextPage}
					                   isOpenLeftMenu={isOpenLeftMenu}
					                   addMusic={addMusic} />
					<FJMediaCollectionView music
					                       onSearch={handleCollection}
					                       collections={collections}
					                       active={active && !expandData}
					                       isOpenLeftMenu={isOpenLeftMenu}/>
				</>
			);
		case STOCK_SEARCH_LOADING:
			return <FJPureLoading active type='content' style={{transform: `translateX(${translateX})`}}/>
		case STOCK_SEARCH_ERROR:
			return <FJFetchError active onRetry={initAudioCollections} style={{transform: `translateX(${translateX})`}}/>;
		default:
			return null;
	}
}

export default FJMusicCollectionContainer;